import { Injectable } from '@angular/core';

import { TenantTheme } from '@models/bootstrap.model';

/**
 * Applies per-tenant theme (colors, fonts, dark mode) at runtime.
 *
 * STUB — intentionally a no-op for now. Runtime theming is out of scope for the
 * current branding work; only the structure is in place so the future
 * implementation is a drop-in. When implemented, this will map the theme tokens
 * onto CSS custom properties (`--brand-*`) and regenerate the PrimeNG preset,
 * per the tenant-branding architecture doc (§8 "Dynamic Theme System").
 *
 * Named `TenantThemeService` to avoid collision with the existing issuer-scoped,
 * post-login `ThemeService` (`core/services/theme.service.ts`).
 */
@Injectable({ providedIn: 'root' })
export class TenantThemeService {
  /**
   * Apply the given theme. No-op today; the parameter is intentionally unused
   * until runtime theming is implemented (kept so callers and the signature are
   * already correct).
   * @param theme Theme tokens from the bootstrap payload.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  applyTheme(theme: TenantTheme): void {
    // TODO(tenant-branding): map theme tokens → CSS variables + PrimeNG preset.
  }
}
